/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Image_DesignInputs */

const vi_shop_group_image_design = /** @type {(inputs: Shop_Group_Image_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở sản phẩm để thiết kế ảnh`)
};

/**

* @param {Shop_Group_Image_DesignInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_image_design = /** @type {((inputs?: Shop_Group_Image_DesignInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Image_DesignInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_image_design(inputs)
});